/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import axios from "axios";
import API_BASE_URL from "./config";

const INIT = { driverId: "", driverName: "", month: "", requestedAmount: "", reason: "" };

export default function ManualRequestForm({ onClose, onSaved }) {
  const [form, setForm]     = useState(INIT);
  const [loading, setLoading] = useState(false);
  const [err, setErr]       = useState("");
  const [ok, setOk]         = useState(false);

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.driverId.trim() || !form.requestedAmount) {
      setErr("Driver ID and Requested Amount are required."); return;
    }
    setErr(""); setLoading(true);
    try {
      await axios.post(`${API_BASE_URL}/advance/manual`, form);
      setOk(true);
      setForm(INIT);
      setTimeout(() => { setOk(false); if (onSaved) onSaved(); }, 1500);
    } catch (error) {
      setErr(error.response?.data?.message || "Submission failed. Check backend.");
    }
    setLoading(false);
  };

  const S = {
    wrap:      { background: "#fffdf0", border: "1px solid #FFC107", borderRadius: 8, padding: "16px 18px", marginBottom: 16, maxWidth: 620 },
    title:     { fontWeight: "bold", fontSize: 13, marginBottom: 12, color: "#000" },
    grid:      { display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 10, marginBottom: 12 },
    label:     { fontSize: 11, fontWeight: "bold", marginBottom: 3, display: "block", color: "#333" },
    input:     { padding: "7px 10px", border: "1px solid black", borderRadius: 5, fontSize: 13, width: "100%", boxSizing: "border-box" },
    textarea:  { padding: "7px 10px", border: "1px solid black", borderRadius: 5, fontSize: 13, width: "100%", boxSizing: "border-box", minHeight: 50, resize: "vertical" },
    btnRow:    { display: "flex", gap: 8 },
    btnYellow: { background: "#FFC107", color: "#000", border: "none", padding: "8px 18px", borderRadius: 5, cursor: "pointer", fontWeight: "bold", fontSize: 13 },
    btnBlack:  { background: "#000", color: "#fff", border: "none", padding: "8px 18px", borderRadius: 5, cursor: "pointer", fontWeight: "bold", fontSize: 13 },
    success:   { background: "#e6f9ee", border: "1px solid #27ae60", color: "#27ae60", padding: "8px", borderRadius: 5, marginTop: 10, fontSize: 13 },
    errBox:    { background: "#fde8e8", border: "1px solid #c0392b", color: "#c0392b", padding: "8px", borderRadius: 5, marginTop: 10, fontSize: 13 },
  };

  return (
    <div style={S.wrap}>
      <div style={S.title}>✏️ Manual Advance Request</div>
      <form onSubmit={handleSubmit}>
        <div style={S.grid}>
          <div>
            <label style={S.label}>Driver ID *</label>
            <input style={S.input} name="driverId" placeholder="e.g. DE0001" value={form.driverId} onChange={handleChange} required />
          </div>
          <div>
            <label style={S.label}>Driver Name</label>
            <input style={S.input} name="driverName" placeholder="Driver name" value={form.driverName} onChange={handleChange} />
          </div>
          <div>
            <label style={S.label}>Month</label>
            <input style={S.input} name="month" type="month" value={form.month} onChange={handleChange} />
          </div>
          <div>
            <label style={S.label}>Requested Amount (₹) *</label>
            <input style={S.input} name="requestedAmount" type="number" min="1" placeholder="0" value={form.requestedAmount} onChange={handleChange} required />
          </div>
        </div>
        <div style={{ marginBottom: 12 }}>
          <label style={S.label}>Reason</label>
          <textarea style={S.textarea} name="reason" placeholder="Reason for advance..." value={form.reason} onChange={handleChange} />
        </div>
        <div style={S.btnRow}>
          <button style={S.btnYellow} type="submit" disabled={loading}>{loading ? "Submitting..." : "✅ Submit"}</button>
          <button style={S.btnBlack} type="button" onClick={onClose}>✕ Close</button>
        </div>
      </form>
      {ok  && <div style={S.success}>✅ Request submitted successfully!</div>}
      {err && <div style={S.errBox}>{err}</div>}
    </div>
  );
}
